import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import config from "../../../baseConfig/index";
import { trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import Modal from "../../Fragments/Modal";
import ErrorModal from "../../Fragments/ErrorModal";

class AddOfficeStep2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: "",
      buttonDisabled: false,
      smsButtonDisabled: false,
      formResponse: "",
      successModal: false,
      showErrorModal: false,
    };

    this.errorCallBack = this.errorCallBack.bind(this);
  }

  lifeTimeConvert() {
    let seconds = this.props.mobileConfig.mobileTimeLife,
      minutes = Math.floor(seconds / 60);

    if (seconds / 60 < 1) {
      minutes = "00";
    }

    if (minutes < 10 && minutes > 0) {
      minutes = "0" + minutes;
    }

    if (seconds > 60) {
      seconds = seconds - minutes * 60;
    }

    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    return minutes + ":" + seconds;
  }

  isFixNumber() {
    let isMobile = "mob";

    if (this.props.mobileConfig.msisdn !== "") {
      for (let i in this.props.config.data.msisdn_pfx.fixed) {
        let prefixCurrent = this.props.config.data.msisdn_pfx.fixed[i],
          pattern = new RegExp("^" + prefixCurrent);

        if (pattern.test(this.props.mobileConfig.msisdn)) {
          isMobile = "fix";
          break;
        }
      }
    }

    return isMobile;
  }

  sendData(event) {
    this.setState({ buttonDisabled: true });

    ApiManager.postRequest(
      {
        code: this.state.code,
        token: this.props.mobileConfig.mobileToken,
        jwt: this.props.getDecryptedToken(),
        _token: this.props.csrf_token.data,
      },
      "/account/" + this.isFixNumber() + "/confirm"
    ).then((resolve) => {
      this.setState({
        buttonDisabled: false,
        formResponse: resolve.data,
      });

      if (resolve.data.status === "OK") {
        this.props.clearAddOfficeTimer();
        this.setState({ successModal: true });
      }
    }, this.errorCallBack);

    event.preventDefault();
  }

  reSendSms() {
    this.setState({ smsButtonDisabled: true });

    ApiManager.postRequest(
      {
        msisdn: this.props.mobileConfig.msisdn,
        jwt: this.props.getDecryptedToken(),
        _token: this.props.csrf_token.data,
      },
      "/account/mob/request"
    ).then((resolve) => {
      this.setState({
        smsButtonDisabled: false,
        formResponse: resolve.data,
      });

      if (resolve.data.hasOwnProperty("token")) {
        let newState = this.props.mobileConfig;

        newState["mobileStep"] = 2;
        newState["mobileTimeLife"] =
          this.props.config.data.mob_code_lifetime * 60;
        newState["mobileToken"] = resolve.data.token;

        this.props.updateParentState(newState);

        this.props.lifeTimeCounter();
      }
    }, this.errorCallBack);
  }

  errorCallBack(reject) {
    this.setState({ showErrorModal: true });
  }

  bottomActionPart() {
    if (this.props.mobileConfig.mobileTimeLife > -1) {
      return (
        <>
          <div className="form__form-box form__form-box--with-space form-box">
            <div className="form__time fs41 tc">{this.lifeTimeConvert()}</div>
          </div>
          <div className="form__desc-txt fs13">
            {trans(this.props.trans, "add.office.phone.sms.description")}
          </div>
        </>
      );
    }

    return (
      <button
        className={`form__btn btn--with-space btn btn--white fs17${
          this.state.smsButtonDisabled ? " btn--loading" : ""
        }`}
        type="button"
        disabled={this.state.smsButtonDisabled}
        onClick={() => this.reSendSms()}
      >
        {trans(this.props.trans, "add.office.phone.sms.button.title")}
      </button>
    );
  }

  resetAction() {
    this.props.refreshAccountList();

    let newState = this.props.mobileConfig;

    newState["msisdn"] = "";
    newState["mobileStep"] = 1;
    newState["mobileTimeLife"] = 0;
    newState["mobileToken"] = "";

    this.props.updateParentState(newState);

    this.props.history.push(config.urlPrefix + "profile/account");
  }

  successModal() {
    if (!this.state.successModal) {
      return "";
    }

    return (
      <Modal
        title={trans(this.props.trans, "add.office.success.title")}
        description={trans(this.props.trans, "add.office.success.description")}
        agreeText={trans(this.props.trans, "add.office.success.agree")}
        agreeAction={() => this.resetAction()}
        className="modal--full"
      />
    );
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  render() {
    let errorMsisdnClass = "",
      errorMsisdnBox = "",
      errorCodeClass = "",
      errorCodeBox = "",
      errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("msisdn")) {
          errorMsisdnClass = " form-error";
          errorMsisdnBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.msisdn}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("code")) {
          errorCodeClass = " form-error";
          errorCodeBox = (
            <div className="form-error-text fs11">
              {this.state.formResponse.errors.code}
            </div>
          );
        }

        if (this.state.formResponse.errors.hasOwnProperty("token")) {
          errorBox = (
            <FormMiddlewareError
              message={this.state.formResponse.errors.token}
            />
          );
        }
      }

      if (
        this.state.formResponse.status === "ERROR" ||
        this.state.formResponse.status === "NOT_FOUND"
      ) {
        errorBox = (
          <FormMiddlewareError message={this.state.formResponse.message} />
        );
      }
    }

    return (
      <section className="main-wrapper__services">
        <h2 className="main-wrapper__sub-title main-wrapper__sub-title--add monserrat-medium pr sprite-b">
          {trans(this.props.trans, "add.office.main_title")}
        </h2>

        <div className="form">
          <form
            action="#"
            method="post"
            onSubmit={(event) => this.sendData(event)}
          >
            <div className={`form__form-box${errorMsisdnClass}`}>
              <label className="form__label db fs11" htmlFor="tel-number">
                {trans(this.props.trans, "add.office.phone.title2")}
              </label>
              <div className="form__field-out form__field-out--with-prefix pr">
                <input
                  className="form__field fs13 disabled"
                  disabled="disabled"
                  id="tel-number"
                  type="text"
                  value={this.props.mobileConfig.msisdn}
                />
              </div>
              {errorMsisdnBox}
            </div>
            <div
              className={`form__form-box form__form-box--with-space${errorCodeClass}`}
            >
              <label className="form__label db fs11" htmlFor="code">
                {trans(this.props.trans, "add.office.phone.sms.title")}
              </label>
              <div className="form__field-out pr">
                <input
                  className="form__field fs13"
                  id="code"
                  type="text"
                  name="code"
                  value={this.state.code}
                  onChange={(event) => {
                    this.setState({
                      code: event.target.value.trim().replace(/[^\d]/g, ""),
                    });
                  }}
                />
              </div>
              {errorCodeBox}
            </div>

            {this.bottomActionPart()}

            {errorBox}

            <button
              className={`form__submit-btn btn btn--yellow fs17${
                this.state.buttonDisabled ? " btn--loading" : ""
              }`}
              type="submit"
              disabled={this.state.buttonDisabled}
            >
              {trans(this.props.trans, "add.office.phone.button.title2")}
            </button>
          </form>

          {this.successModal()}
          {this.errorModal()}
        </div>
      </section>
    );
  }
}

export default withRouter(AddOfficeStep2);
